package com.ijoin.platform

@JsFun("function(value){ return encodeURIComponent(value); }")
private external fun encodeComponent(value: String): String

actual fun encodeUrlComponent(value: String): String = encodeComponent(value)
